import { createContext, useContext, useEffect, useMemo } from 'react';
import { ApprovalActions } from 'ui-product-approvals-common';
import { useApprovalConfig } from 'ui-product-approvals/hooks/useApprovalConfig';
import usePrevious from 'react-utils/hooks/usePrevious';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentApprovalsContext = /*#__PURE__*/createContext(undefined);
export const ContentApprovalsProvider = ({
  approvalType,
  hasApprovalsReadAccess,
  children
}) => {
  const approvalConfig = useApprovalConfig(approvalType, ApprovalActions.PUBLISH);
  const prevApprovalType = usePrevious(approvalType);
  useEffect(() => {
    if (approvalType !== prevApprovalType && hasApprovalsReadAccess) {
      approvalConfig.fetchConfig();
    }
  }, [approvalConfig, approvalType, hasApprovalsReadAccess, prevApprovalType]);
  const areApprovalsEnabled = useMemo(() => {
    return !!(!approvalConfig.isLoading && approvalConfig.config.enabled);
  }, [approvalConfig]);
  return /*#__PURE__*/_jsx(ContentApprovalsContext.Provider, {
    value: areApprovalsEnabled,
    children: children
  });
};
export const useApprovalsData = () => {
  const areApprovalsEnabled = useContext(ContentApprovalsContext);
  return useMemo(() => ({
    areApprovalsEnabled: areApprovalsEnabled === undefined ? false : areApprovalsEnabled
  }), [areApprovalsEnabled]);
};